export const ALL_PLATFORMS = ['APNS', 'APNS_SANDBOX', 'GCM'];
